const semanticClassNames = {
  root: 'text-on-path',
} as const;

export default semanticClassNames;
